import { EditColumns } from "../models";

export const createEditColumns = (c: { [key: string]: { show: boolean } }): EditColumns => {
  return Object.keys(c).reduce((acc, key, index) => {
    acc[key] = { show: c[key].show, index };
    return acc;
  }, {} as EditColumns);
};
